module.exports = __webpack_public_path__ + "static/media/event-24px.7d7204ea.svg";